"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cos = void 0;
var utils_1 = require("../../utils");
var qs = require("qs");
exports.cos = function (axios) {
    return {
        /** @description 코스 섹션 조회 https://internal-docs.nhn-commerce.com/?url.primaryName=cos-admin/#/Section/get-section-with-sub-contents */
        getCosSectionsSectionCode: function (request) {
            var query = qs.stringify(request.params, { arrayFormat: 'comma' });
            var url = utils_1.paramPathchange('/cos/sections/{sectionCode}', request);
            return axios.get(url + "?" + query);
        },
        getCosBoardsBoardCodeSummary: function (request) {
            var query = qs.stringify(request.params);
            var url = utils_1.paramPathchange('/cos/boards/{boardCode}/summary', request);
            return axios.get(url + "?" + query);
        }
    };
};
